import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Card, Pagination, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import {
  COUPON_HISTORY_STATUS,
  CouponService,
  ICoupon,
  ICouponHistory,
} from "service/coupon/service";

function CouponIssueList() {
  const [couponHistoryList, setCouponHistoryList] = useState<ICouponHistory[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [couponList, setCouponList] = useState<ICoupon[]>([
    {
      coupon_id: 0,
      create_time: "",
      description: "쿠폰 선택",
      discount_value: 0,
      grade: "",
      name: "",
      region_type: "",
      type: "",
      use_days: "",
      valid_days: 0,
      valid_from: "",
      valid_to: "",
    },
  ]);
  const [search, setSearch] = useState("");
  const [selectedCoupon, setSelectedCoupon] = useState(0);
  const [selectedUsed, setSelectedUsed] = useState("");
  const [issueDateSort, setIssueDateSort] = useState("AD");
  const [expirationDateSort, setExpirationDateSort] = useState("BD");

  const getCouponHistoryList = async (
    search: string,
    couponId: number,
    isUsed: string,
    issueDateSort: string,
    expirationDateSort: string,
    page: number
  ) => {
    const data = await CouponService.couponHistory(
      search,
      couponId,
      isUsed,
      issueDateSort,
      expirationDateSort,
      10,
      page
    );
    setCouponHistoryList(data.list);
    setTotalPages(Math.ceil(Number(data.totalCount) / 10));
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    const getCouponList = async (page: number) => {
      const data = await CouponService.couponList(100, page);
      setCouponList((prev) => [...prev, ...data.list]);
    };

    getCouponList(1);
  }, []);

  useEffect(() => {
    getCouponHistoryList(
      search,
      selectedCoupon,
      selectedUsed,
      issueDateSort,
      expirationDateSort,
      currentPage
    );
  }, [selectedCoupon, selectedUsed, issueDateSort, expirationDateSort, currentPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              placeholder="쿠폰명, ID, 회원명 등을 입력해주세요."
              style={{ padding: "8px", width: "300px" }}
              onChange={(e: any) => setSearch(e.target.value)}
            />
            <div
              style={{
                padding: "8px",
                backgroundColor: "rgb(30, 155, 107)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "13px",
                fontWeight: 600,
                color: "white",
                borderRadius: "8px",
                width: "50px",
                cursor: "pointer",
              }}
              onClick={() => {
                setCurrentPage(1);
                getCouponHistoryList(
                  search,
                  selectedCoupon,
                  selectedUsed,
                  issueDateSort,
                  expirationDateSort,
                  1
                );
              }}
            >
              검색
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <select
                name="쿠폰 선택"
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSelectedCoupon(e.target.value)}
              >
                {couponList.map((el, idx) => {
                  return (
                    <option value={el.coupon_id} key={idx}>
                      {el.name || el.description}
                    </option>
                  );
                })}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <select
                name="사용여부"
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSelectedUsed(e.target.value)}
              >
                {[
                  {
                    label: "사용여부",
                    value: "",
                  },
                  {
                    label: "사용",
                    value: "Y",
                  },
                  {
                    label: "미사용",
                    value: "N",
                  },
                ].map((el, idx) => {
                  return (
                    <option value={el.value} key={idx}>
                      {el.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => setIssueDateSort(issueDateSort === "AD" ? "AA" : "AD")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "6px 12px",
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                }}
              >
                지급일자 {issueDateSort === "AD" ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
              </button>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <button
                onClick={() => setExpirationDateSort(expirationDateSort === "BD" ? "BA" : "BD")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                  padding: "6px 12px",
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                }}
              >
                사용기한 {expirationDateSort === "BD" ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
              </button>
            </div>
          </div>
        </div>
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  <tr
                    style={{
                      fontSize: "14px",
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "16px",
                      fontFamily: "Pretendard",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <th>idx</th>
                    <th>쿠폰명</th>
                    <th>ID(이메일)</th>
                    <th>회원명</th>
                    <th>사용여부</th>
                    <th>사용일자</th>
                    <th>사용기한</th>
                    <th>지급일자</th>
                  </tr>
                </thead>
                <tbody>
                  {couponHistoryList.map((history: ICouponHistory, idx: number) => {
                    return (
                      <tr
                        key={idx}
                        style={{
                          fontSize: 12,
                          color: "#000000DE",
                          textAlign: "center",
                          fontFamily: "Pretendard",
                        }}
                      >
                        <td style={{ padding: "16px 8px" }}>{(currentPage - 1) * 10 + idx + 1}</td>
                        <td style={{ padding: "16px 8px" }}>{history.coupon_name}</td>
                        <td style={{ padding: "16px 8px" }}>{history.email}</td>
                        <td style={{ padding: "16px 8px" }}>{history.name}</td>
                        <td style={{ padding: "16px 8px" }}>
                          {
                            COUPON_HISTORY_STATUS[
                              history.status as keyof typeof COUPON_HISTORY_STATUS
                            ]
                          }
                        </td>
                        <td style={{ padding: "16px 8px" }}>{history.use_time}</td>
                        <td style={{ padding: "16px 8px" }}>{history.expire_time}</td>
                        <td style={{ padding: "16px 8px" }}>{history.create_time}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}

export default CouponIssueList;
